import { UserManagerService } from './../userManager/user-manager.service';
import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { Cagnotte } from 'src/models/race-data.model';
import { isMultiGame } from 'src/functions/multi-game.function';
import $ from 'jquery';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { TurfEndpoints, EndPoints } from '../../configs/api.configs';
import { TurfBetObject } from '../../models/bet-object.model';
import { TurfSaveBetParam } from '../../models/saloon-models/save-bet-options.model';
import { ConfigService } from '../config/config.service';
import { HttpService } from '../helper/http.service';
import { ModalService } from '../modal-service/modal.Service';
import { SkeletonServiceService } from '../skeleton/skeleton.service';
import { StorageService } from '../storage/storage.service';
import { ThemeService } from '../theme/theme.service';
import { environment } from 'src/environments/environment';
import { FINISHED_RACE_RAPPORTS_20250926 } from 'src/sample-data/race-rapport.data';

// declare var $: any;

@Injectable({
  providedIn: 'root',
})
export class TurfServiceService {
  public requireConfirmation: boolean = false;
  private _meetingId: any;
  private _raceId: any;
  private _raceReport: any;
  // public reportParticipants: any;
  public betObject: any;
  public selectedMeeting: any;
  public reportResults: any = [];
  public racesInMeeting: any;
  public eventDate = new Date();
  public betsArray: Array<TurfBetObject> = [];
  public selectedHorses: Set<string> = new Set();
  activeRaceInSelectedMeeting: any;
  partantsInactiveRace: any = [];
  activeGameObject: any;
  checkBoxConfig: any;
  casaqueCourse: any;
  onBetOptionSelected$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  courseChange$: Subject<any> = new Subject();
  activeReport: any;
  activeReportNonPartant: any;
  reportPartants: any = [];
  reportRap: any = [];
  nonPartant: any;
  report: any;
  spotGametype: boolean = false;
  betLoader = false;

  activeRaceDetail: any;
  activeCombinationBtn: any;
  activeBets: TurfBetObject[] = [];
  reportLoader: boolean = false;
  onViewReportClickEvent$: Subject<{}> = new Subject();
  onActiveRaceClickEvent$: Subject<{}> = new Subject();
  amountTotal: number = 0;
  betAmount: number = 0;
  combinations: any;
  combinationsValue: number = 0;
  activeCombinations: number = 0;
  disbld: boolean = false;
  alert: boolean = false;
  spotIcon: any;
  scoltop: string = "";
  national: any;
  private savebetParam!: TurfSaveBetParam;
  toutOdre: any = false;
  cagnoteGames: Cagnotte[] = [];
  message: any;
  partants: any;
  rawActiveGames!: Promise<any>;
  load: boolean = false;
  games: any;
  maxSelections = false;
  constructor(
    private httpHandler: HttpService,
    public userService: UserManagerService,
    public storageService: StorageService,
    private translate: TranslateService,
    private modalService: ModalService,
    private configService: ConfigService,
    private skeletonService: SkeletonServiceService,
    private themeService: ThemeService

  ) {
    //  console.log( 'event Date' , this.eventDate);
    //  let me = this
    // this.websocket.getCagnote.subscribe((data)=>{
    //   if(data.length > 0){
    //     me.cagnoteGames = data;
    //     console.log('cagnots', me.cagnoteGames)
    //   }
    //   me.cagnoteGames= []
    // })
  }
  racereport() {
    const me = this;
    me.onViewReportClickEvent$.subscribe((report) => {
      if (report.hasOwnProperty('id')) {
        me.report = report;
        // console.log(report, 'race-report')
        this.nonPartant = this.report.nonPartant;
        // return this.nonPartant;
      } else {
        me.report = [];
      }
    });
  }

  helloTurf() {
    // console.log("hello from truf service");
  }

  public get getMeetingId() {
    return this._meetingId;
  }

  public set setMeetingId(value: any) {
    this._meetingId = value;
  }

  public get getRaceId() {
    return this._raceId;
  }

  public set setRaceId(value: any) {
    this._raceId = value;
  }

  public get getraceReport() {
    return this._raceReport;
  }

  public set setraceReport(value: any) {
    this._raceReport = value;
  }

  onMeetingSelect(meeting: any) {
    if (this.selectedMeeting == meeting) {
      return;
      // this.storageService.deleteItem("selectedMeeting");
    } else {
      this.selectedMeeting = meeting;
      this.racesInMeeting = meeting.races;

      this.storageService.save('selectedMeeting', meeting);
    }
  }

  formatHeader(eventDate?: any) {
    // console.log("event date" , this.eventDate)
    moment.locale(this.translate.currentLang);

    const today = eventDate
      ? moment(eventDate).format('LLLL')
      : moment().format('LLLL');

    const todayArr = today.split(' ');

    return (
      todayArr[0] + ' ' + todayArr[1] + ' ' + todayArr[2] + ' ' + todayArr[3]
    );
  }

  formatDate(date: Date) {
  const monthNames = [
    '01', '02', '03', '04', '05', '06',
    '07', '08', '09', '10', '11', '12',
  ];

  const day = String(date.getDate()).padStart(2, '0');
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}


  casaqueCourseUrl(cNumber?: any, rNumber?: any) {
    let raceNumber = cNumber;
    let meetingNumber = rNumber;
    if (!rNumber) {
      const meetingObj = this.selectedMeeting
        ? this.selectedMeeting
        : this.storageService.getObject('selectedMeeting', false);
      meetingNumber = meetingObj.nReunion;
    }
    if (!cNumber && this.activeRaceInSelectedMeeting) {
      raceNumber = this.activeRaceInSelectedMeeting.course_number;
    }

    return (
      this.formatDate(this.eventDate).replace(/[/]/g, '') +
      '/R' +
      meetingNumber +
      '/C' +
      raceNumber +
      '/P'
    );
  }

  onRaceSelect(race: any, national?: any) {
    this.national = '';
    this.activeRaceDetail = national ? 'national' : '';
    if (!$('#race-' + race.numero + national).hasClass('open')) {
      // close all open details
      $('[id^=\'race-\']').removeClass('open');
      $('[id^=\'race-details-\']').css('display', 'none');

      // close all report details
      $('[id^=\'race-\']').removeClass('open');
      $('[id^=\'report-\']').css('display', 'none');

      this.initRaceDetailsComponentData(race);

      $('#race-' + race.numero + national).addClass('open');

      // show race details view
      $('#race-details-' + race.numero + national).css('display', '');
      this.scoltop = 'race-' + race.numero;
      this.national = national;
      // this.onWindowScroll("#race-" + race.numero + national)
    } else {
      $('#race-' + race.numero + national).removeClass('open');
      this.scoltop = '';
      // hide race details view
      $('#race-details-' + race.numero + national).css('display', 'none');
    }
  }

  initRaceDetailsComponentData(race: { partants: any; course_number: any; }) {
    this.activeCombinationBtn = 1;
    this.activeRaceInSelectedMeeting = race;
    this.partantsInactiveRace = race.partants;
    // this.onGameTypeSelect(race.jeu.split("@")[0]);
    this.casaqueCourse = this.casaqueCourseUrl(race.course_number);
  }

  showSpotIcon() {
    let moveout = false;
    // console.log(this.activeRaceInSelectedMeeting)
    if (!this.activeRaceInSelectedMeeting.jeu) {
      return
    }
    for (const game of this.activeRaceInSelectedMeeting.jeu.split('@')) {
      if (game.includes('|SI, CE')) {
        this.spotIcon = true;
        // console.log("show Spot")
        moveout = true;
        break;
      }
      if (moveout) {
        break;
      }
    }
  }
  onGameTypeSelect(game: string) {
    // set active btn to standard
    this.showSpotIcon();
    if (this.spotGametype) {
      this.activeCombinationBtn = 2;
    } else {
      this.activeCombinationBtn = 1;
    }
    this.betAmount = 0;
    const gameInfo = game.split('-');

    this.activeGameObject = {
      icon: gameInfo[0],
      prixdeBase: gameInfo[1],
      coefMax: gameInfo[2],
      numbreCheveauxBase: Number(gameInfo[3]),
      formuleDeJeur: gameInfo[4].split(','),
      color: gameInfo[5],
      touteOdre: gameInfo[6],
      flexi: gameInfo[7],
      spot: gameInfo[8],
      spotChevalLength: Number(gameInfo[8].split('|')[0]),
    };
    // console.log("checking for spot games", this.activeGameObject);

    let checkBoxConfig;

    if (this.activeGameObject.formuleDeJeur.length < 2) {
      checkBoxConfig = {
        name: this.gameTypeToName(this.activeGameObject.icon),
        nbtn: 1,
        stand: true,
        hasChamp: false,
      };
    } else if (this.activeGameObject.formuleDeJeur.length > 2) {
      checkBoxConfig = {
        name: this.gameTypeToName(this.activeGameObject.icon),
        nbtn: 2,
        stand: true,
        champ: true,
        hasChamp: true,
      };
    } else {
      checkBoxConfig = {
        name: this.gameTypeToName(this.activeGameObject.icon),
        nbtn: 2,
        stand: true,
        champ: true,
        hasChamp: true,
      };
    }

    this.activeGameObject.check = checkBoxConfig;
    this.onBetOptionSelected$.next(true);
  }

  gameTypeToName(gameType: string) {
    let gameName = '';

    switch (gameType) {
      case 'PSG':
        gameName = 'gm_simple_gagnant';
        break;

      case 'PSP':
        gameName = 'gm_simple_place';
        break;

      case 'PCG':
        gameName = 'gm_couple_gagnant';
        break;

      case 'PCP':
        gameName = 'gm_couple_place';
        break;

      case 'P24':
        gameName = 'gm_2_sur_4';
        break;

      case 'PTRIO':
        gameName = 'gm_ptrio';
        break;

      case 'PMM':
        gameName = 'gm_multi';
        break;

      default:
        gameName = 'gm_' + gameType.toLowerCase();
        break;
    }

    return gameName;
  }

  viewReport(race: any, national?: any) {

    this.activeRaceDetail = national ? 'national' : '';
    if (!$('#race-' + race.numero + national).hasClass('open')) {
      $('[id^=\'race-\']').removeClass('open');
      $('[id^=\'report-\']').css('display', 'none');

      // close all open details
      $('[id^=\'race-\']').removeClass('open');
      $('[id^=\'race-details-\']').css('display', 'none');

      // show loader
      $('#report-loader-' + race.numero + national).css('display', '');
      $('#race-' + race.numero + national).addClass('open');

      // show race details view
      $('report-' + race.numero + national).css('display', '');

      this.scoltop = 'race-' + race.numero + national;

      this.getReportData(this.selectedMeeting.numero, race.numero, national);
      this.scoltop = 'race-' + race.numero + national;
      this.national = national;

      // this.onWindowScroll("race-" + race.numero)

      // $('#race-' + race.numero).addClass('open');

      // // show report section
      // $('#report-' + race.numero).css('display', '');

      // show close btn
      // $('#closeRaceBt-' + race.numero).css('display', 'block');
    } else {
      this.activeReport = {};
      $('#race-' + race.numero + national).removeClass('open');

      // hide report section
      $('#report-' + race.numero + national).css('display', 'none');
      this.scoltop = '';
    }
  }

  remove() {
    this.betsArray = [];
    this.selectedHorses.clear();
    this.betObject = {};
    this.disbld = false;
    this.activeCombinations = 0;
    this.clearCache();
    this.betAmount = 0;
    this.maxSelections = false;
  }

  initReportComponentData(report: any) {
    this.activeReport = report;
    this.reportPartants = this.orderWinningPartants(
      this.activeReport.arrivee,
      this.activeReport.partants
    );

    this.casaqueCourse =
      this.formatDate(new Date(this.eventDate)).replace(/[/]/g, '') +
      '/R' +
      this.activeReport.rNumber +
      '/C' +
      this.activeReport.cOrder +
      '/P';

    this.reportRap = this.activeReport.rap ? this.formateResultObj(this.activeReport.rap) : [];
  }

  formateResultObj(reportObj: { [x: string]: any; }) {
    const reportArr: any[] = [];

    Object.keys(reportObj).forEach((key) => {
      const obj = reportObj[key];
      obj.key = key;
      reportArr.push(obj);
    });

    return reportArr;
  }

  orderWinningPartants_(partants: string | any[], arrivee: string | any[]) {
    const orderdPartants = [];
    // const arriveeArr = arrivee.split('-');
    for (let i = 0; i < arrivee.length; i++) {
      const arriKey = arrivee[i];
      for (let j = 0; j < partants.length; j++) {
        const partant = partants[j];
        if (arriKey === partant.numero) {
          orderdPartants.push(partant);
        }
      }
    }

    return orderdPartants;
  }

  orderWinningPartants(arrivee: string, partants: any[]) {
    const result: any[] = [];
    const order = arrivee.split('-').map((x: string | number) => +x);
    order.forEach(function (key: any) {
      let found = false;
      partants = partants.filter(function (item: { numero: any; }) {
        if (!found && item.numero == key) {
          result.push(item);
          found = true;
          return false;
        } else {
          return true;
        }
      });
    });
    return result;
  }

  ojectToArrOfOject(obj: {}) {
    const arrOfObj: never[] = [];

    Object.keys(obj).forEach((key) => { });

    return arrOfObj;
  }

  clearReportComponentValues() {
    this.activeReport = {};
    // this.reportPartants = this.activeReport['partants'];
    this.reportPartants = [];

    this.casaqueCourse = '';

    this.reportRap = [];
  }

  getReportData(meetingId: any, raceId: any, national?: any) {
    const params = { cid: raceId, rid: meetingId };
    let courses = {
        arrivee: '',
        partants: [],
        rap: null,
        rNumber: meetingId,
        cOrder: raceId
      };
    this.clearReportComponentValues();
    this.getRaceReport(params).then((resp) => {
      $('#report-loader-' + raceId + national).css('display', 'none');

      if(resp.hasOwnProperty('tcourse') && resp.tcourse.length > 0) {
        courses = resp.tcourse[0];
      }

      this.initReportComponentData(courses);

      // console.log('open drop-down');
      $('#race-' + raceId + national).addClass('open');

      // show report section
      $('#report-' + raceId + national).css('display', '');
    });
  }

  scrollToElement(param: string, type?: string) {
    let elementList;
    if (type && type === 'class') {
      elementList = document.querySelectorAll('.' + param);
    } else {
      elementList = document.querySelectorAll('#' + param);
    }
    const element = elementList[0] as HTMLElement;
    element.scrollIntoView({ behavior: 'smooth' });
  }

  // HTTP Requests
  getActiveGames(eventData?: any): Promise<any> {
    var params: any = {
      channel: 7,
      versioncode: 3,
      date_jr: eventData ? moment(eventData).format('YYYY-MM-DD') : ''
    };

    let endpoint = this.configService.loadRacesFromCache ? TurfEndpoints.getCachedActiveGames : TurfEndpoints.getActiveGames
    let gateway = this.configService.loadRacesFromCache ? environment.API.cache_turf_gateway : environment.API.turf_gateway;

    this.rawActiveGames = this.httpHandler.get_no_auth(
      gateway +
      endpoint,
      params
    );
    return this.rawActiveGames;
  }

  getRaceReport(params: { cid: any; rid: any; }): Promise<any> {
    // return new Promise((resolve, reject) => {
    //   resolve(FINISHED_RACE_RAPPORTS_20250926);
    // });
    return this.httpHandler.get_no_auth(
      environment.API.turf_gateway + TurfEndpoints.getRaceReport,
      params
    );
  }
  calculateNewAmount(data: TurfBetObject) {
    if (!Number(data.coef) || !Number(data.coefMax)){
      this.betAmount = 0;
    }else {
      if (!(Number(data.coef) && (Number(data.coef) <= Number(data.coefMax)))) {
        this.alert = true;
      }
      this.alert = false;
      this.betAmount = this.getAmount(data);
      data.value = this.betAmount;
      data.combinations = this.combinationsValue;
    }

  }
  clearCache() {
    this.storageService.delete_cookie("betObject")
    this.storageService.delete_cookie("selectedHorses")
    this.storageService.delete_cookie("betsArray")
    this.storageService.delete_cookie("activeRace");
    this.storageService.delete_cookie("activeGameObject");
    this.storageService.delete_cookie("activeObject");
    this.storageService.delete_cookie("activeBets");
    this.storageService.delete_cookie("spotGametype");

  }
  getTotalAmount() {
    const amount = 0;
    // this.betsArray.forEach(bet => {
    //   amount += bet.value
    // })
    return this.betAmount;
  }
  getTotalCombinationsValue() {
    let combinaison = 0;
    if (this.betsArray && this.betsArray.length > 0) {
      // console.log(this.activeBets);

      this.betsArray.forEach((bet: any) => {
        if (this.activeGameObject.icon == bet.game) {
          combinaison += bet.combinations;
        }
      });
    }
    this.activeCombinations = combinaison;
  }
  getOffset(el: { getBoundingClientRect: () => any; }) {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY
    };
  }
  getAmount(data: TurfBetObject | any): any {

    let partants = this.getNonPartant(this.activeRaceInSelectedMeeting) ? data.race.partants - this.getNonPartant(this.activeRaceInSelectedMeeting).split('-').length : data.race.partants
    // console.log( this.activeGameObject)
    this.combinationsValue = this.combinaisonCount(
      data.gameType,
      this.activeGameObject.touteOdre == '0' ? false : true,
      this.toutOdre,
      ['CT', 'CP'].includes(data.gameType) ? 0 : data.chavalBase.length,
      data.chavalBase.slice(this.activeGameObject.numbreCheveauxBase).length +
      data.chevalAssocie.length,
      partants,
      data.chavalBase
        .slice(0, this.activeGameObject.numbreCheveauxBase)
        .filter((horseNumber: string) => {
          return horseNumber !== 'X';
        }).length,
      this.activeGameObject.numbreCheveauxBase
    );
    this.amountTotal = this.combinationsValue * data.miseDeBase * data.coef;
    data.value = this.amountTotal;
    data.combinations = this.combinationsValue;
    this.amountTotal = this.amountTotal;
    return this.amountTotal + '';
  }
  arrangement(k: number, n: number): any {
    let r = 1;
    for (let i = 0; i < k; i++) {
      r *= n - i;
    }
    return r;
  }
  combinaison(k: number, n: number): any {
    let r = 1;
    for (let i = 0; i < k; i++) {
      // if (n != i)
      r = (r * (n - i)) / (i + 1);
    }
    // console.log(r);
    return r;
  }
  combinaisonCount(formule: string, ordre: boolean, toutOrdre: any, k: any, p: any, n: number, b: number, s: number): any {
    // console.log(formule, ordre, toutOrdre, k, p, n, b, s);
    if (!ordre) {
      // console.log("odre false");
      if (formule == 'CE') {
        return this.combinaison(s, k);
      }
      if (formule == 'CP') {
        return this.combinaison(s - b, p);
      }
      if (formule == 'CT') {
        return this.combinaison(s - b, n - b);
      }

    } else {
      if (!toutOrdre) {
        // console.log("odre true ttodre false");
        if (formule == 'CE') {
          return this.combinaison(s, k);
        }
        if (formule == 'CP') {
          return this.arrangement(s - b, p);
        }
        if (formule == 'CT') {
          return this.arrangement(s - b, n - b);
        }
      } else {
        // console.log("odre true ttodre true");
        if (formule == 'CE') {
          return this.arrangement(s, k);
        }
        if (formule == 'CP') {
          return this.arrangement(b, s) * this.arrangement(s - b, p);
        }
        if (formule == 'CT') {
          return this.arrangement(b, s) * this.arrangement(s - b, n - b);
        }
        if (formule == 'SI') {
          return this.arrangement(s, s);
        }
      }
    }
    return 1;
  }
  getNonPartant(race: { partants: any[]; }) {
    const nonPartants: any[] = [];
    if (race.partants) {
      race.partants.forEach((partant: { status: string; numero: any; }) => {
        if (partant.status !== 'Partant') {
          nonPartants.push(partant.numero);
        }
      });
      return nonPartants.join('-');
    } else {
      return '';
    }
  }

  SaveBet(): Promise<any> {

    const myHorsesArray = [];

    this.activeBets[0]?.chavalBase?.forEach(horse => {
      myHorsesArray.push(horse);
    });

    if(this.betObject.gameType == 'CP' && this.betObject.chevalAssocie.length == 1){
      this.betLoader = false;
      return Promise.reject("ml_compl_horses_not_valid")
    }
    if (this.activeBets[0].chevalAssocie) {
      for (const horse of this.activeBets[0].chevalAssocie) {
        myHorsesArray.push(horse);
      }
    }
    if (
      !this.userService.userData ||
      (this.userService.userData && !this.userService.userData.lg_AGENT_ID && !this.userService.userData.customer_ID && !this.configService.partnerOperation.enabled)
    ) {
      this.requireConfirmation = true;

      this.betLoader = false;
      return Promise.reject("ml_login_to_bet")
    }


    let flexi = this.activeGameObject.flexi == '1.0' ? 1 : 0;
    const multi = isMultiGame(this.activeGameObject.icon) ? '1' : '0'

    const odre =
      this.toutOdre
        ? 1
        : 0;
    const spotGametype = this.spotGametype ? '1' : '0';
    // odre = odre ? 1 : 0;
    flexi = 0;
    this.activeGameObject.compl = this.betObject.compl
      ? this.activeGameObject.compl
      : 0;
    let format = "";
    const touteOdre = !this.selectedHorses ? this.activeGameObject.touteOdre : odre;
    const betOptions = this.themeService.getTheme().saveBetOptions;
    switch (betOptions.version) {
      case '4.3':
          format = `${!this.selectedHorses ? this.activeGameObject.icon : this.activeGameObject.icon.split('_')[0]}-${touteOdre}-${this.activeGameObject.compl}-${this.betObject.coef}` +`-${flexi}-${spotGametype}-${multi}-${myHorsesArray.join("-")}`
        break;
      case '4.0':
        format = `${!this.selectedHorses ? this.activeGameObject.icon : this.activeGameObject.icon.split('_')[0]}-${touteOdre}-${this.activeGameObject.compl}-${this.betObject.coef}` +`-${flexi}-${spotGametype}-${myHorsesArray.join("-")}`
        break;

      default:
        break;
    }


    let number = this.activeRaceInSelectedMeeting.numero;
    format = format.replace(/X/g, '*');
    let ref = new Date().getTime().toString();

    /*
       mtv: this.activeGameObject.numbreCheveauxBase ? this.activeGameObject.numbreCheveauxBase : undefined, */

    let info = {
      meetingName: this.betObject.reunion.name,
      meetingNumber: this.activeRaceInSelectedMeeting.reunion_num,
      raceName: this.betObject.race.name,
      raceNumber: number,
      toutOrdre: Boolean(touteOdre),
      formula: this.betObject.gameType,
      racetime: this.betObject.race.raceStartUtc ?? this.betObject.race.date,
      pick: myHorsesArray.join("-"),
      currency: this.configService.currency.length ? this.configService.currency : this.configService.currencyData.strCode,
      spot: Boolean(Number(spotGametype)),
      gameName: this.translate.instant(this.gameTypeToName(this.betObject.game)),
    }

    let partnerInfo = this.configService.partnerOperation;
    if(partnerInfo.enabled == true){
      let partnerSaveBetParam = {
        operatorName: partnerInfo.operatorName,
        sessionId: this.userService.userData.sessionId,
        userName: this.userService.userData.login,
        number: this.betObject.race.number,
        info,
        pick: myHorsesArray.join("-"),
        format,
        ref,
        channel: 6,
        intCoef: this.betObject.coef,
        product: this.configService.partnerConfigs.productName,
        amount: this.betAmount,
        option: this.betObject.gameType,
        clientExternalKey: this.userService.userData.clientExternalKey,
      }
      return this.savePartnerBet(partnerSaveBetParam);
    }else {
      this.savebetParam = {
        channel: 3,
        userid: this.userService.userData.customer_ID,
        pwd: this.themeService.useGateway ? this.userService.userData.session : `${this.userService.userData.pin}@NO_CRYPT`,
        ref,
        internal_ref: ref,
        str_From: this.userService.userData.phone_number.toString().replace(/ /g, ''),
        format,
        mtv: this.activeGameObject.numbreCheveauxBase ? this.activeGameObject.numbreCheveauxBase : undefined,
        number,
        sid: this.userService.userData.session,
        uid: this.userService.userData.customer_ID
      };
      return this.saveBet(this.savebetParam);
    }

  }

  savePartnerBet(partnerSaveBetParam: any){
    return this.httpHandler.PostBearerToken(environment.API.partner_gateway, EndPoints['iframe_place_bet'], partnerSaveBetParam, this.userService.userData.authToken)
  }

  saveBet(savebetParam: any){
    return this.httpHandler.HttpParamsPost(
      environment.API.save_bet + TurfEndpoints['saveBet'],
      savebetParam
    );}
}
